export interface Bonus {
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    title: '🎁 BONUS 1 — Junior & Group Golf Coaching Vault™',
    description:
      'Ready-made junior sessions, group games, stations, challenges, clinics, and mixed-ability adaptations.',
  },
  {
    title: '🎁 BONUS 2 — On-Course Coaching Master System™',
    description:
      'On-course assessments, observation tools, playing challenges, decision-making activities, session structures, and post-round reviews.',
  },
  {
    title: '🎁 BONUS 3 — Golf Challenge & Performance Vault™',
    description:
      'Ready-to-run putting, short-game, wedge, iron, driving, pressure, competitive, and performance challenges.',
  },
  {
    title: '🎁 BONUS 4 — Golf Player Communication & Retention Kit™',
    description:
      'Welcome messages, lesson recaps, practice assignments, follow-ups, progress updates, and player communication templates.',
  },
  {
    title: '🎁 BONUS 5 — Golf Coach Quick Adaptation Toolkit™',
    description:
      'Quick solutions for changing session time, difficulty, player level, group size, available space, equipment, or coaching objective.',
  },
]
